module.exports = __webpack_public_path__ + "img/postbox.5bc51faa.svg";